import styled from 'styled-components';

export const LimitToggler = styled.a`
  font-size: 10px;
  color: var(--dark-blue);
  padding: 3px 7px;
`;
